import { render, staticRenderFns } from "./ViewJobDetails.vue?vue&type=template&id=0a275eaa&scoped=true"
import script from "./ViewJobDetails.vue?vue&type=script&lang=ts"
export * from "./ViewJobDetails.vue?vue&type=script&lang=ts"
import style0 from "./ViewJobDetails.vue?vue&type=style&index=0&id=0a275eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a275eaa",
  null
  
)

export default component.exports